import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/storage'
import 'firebase/auth'
import store from './index'
import { findOrCreateNoteHelper } from '../js/noteTemplates/noteHelpers'
import { getCurrentSession } from '../js/noteTemplates/sessionsHelper'
// require('firebase/firestore')
// require('firebase/functions')

// firebase.firestore.setLogLevel('debug')

const config = {
  apiKey: 'AIzaSyDhyHSx4xhFm-w-JA58P_5Mrx75J2meLjo',
  authDomain: 'submindfire.firebaseapp.com',
  databaseURL: 'https://submindfire.firebaseio.com',
  projectId: 'submindfire',
  storageBucket: 'gs://submindfire.appspot.com',
  messagingSenderId: '658753615706'
}

firebase.initializeApp(config)

var refs = {
  db: null,
  storage: null,
  userDocRef: null,
  isReady: {},
  functions: firebase.functions
}

function clearRefs () {
  Object.keys(refs).forEach(k => {
    if (k === 'userDocRef') {
      refs['userDocRef'] = null
    } else if (k === 'isReady') {
      refs['isReady'] = {}
    } else if (k === 'db') {
      // do nothing
    } else if (k === 'storage') {
      // do nothing
    } else if (k === 'functions') {
      // do nothing
    } else {
      // delete all other keys!
      delete refs[k]
    }
  })
}

function allReady () {
  return Object.keys(refs.isReady).every((k) => refs.isReady[k])
}

function updateReadyInStore () {
  store.commit('setFirestoreReady', allReady())
  if (allReady()) {
    store.dispatch('setTreeRoot', getCurrentSession().rootNoteId || null)
  }
}

let cancellers = {}

function cancelAllOnSnapshot () {
  Object.keys(cancellers).forEach(k => {
    cancellers[k]() // Cancel it!
    delete refs.isReady[k]
  })
}

function capitalizeFirstLetter (string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

function addOnSnapshot (collection) {
  // Cancel if it already exists
  if (collection in cancellers) cancellers[collection]()
  refs.isReady[collection] = false
  updateReadyInStore()
  refs[collection + 'ColRef'] = refs.userDocRef.collection(collection)
  const noteHelperPromises = []
  cancellers[collection] = refs[collection + 'ColRef'].onSnapshot(async querySnapshot => {
    // const items = {}
    // querySnapshot.forEach(doc => {
    //   items[doc.id] = {id: doc.id, ...doc.data()}
    // })
    // store.commit('update' + capitalizeFirstLetter(collection), items)
    querySnapshot.docChanges().forEach((docChange) => {
      let data = docChange.doc.data()
      if (!data.createdAt) data.createdAt = data.updatedAt
      if (data.updatedAt) data.updatedAt = data.updatedAt.toDate()
      if (data.createdAt) data.createdAt = data.createdAt.toDate()
      let d = { id: docChange.doc.id, ...data }
      let source = docChange.doc.metadata.hasPendingWrites ? 'Local' : 'Server'
      // store.commit('updateOnlineStatus', docChange.doc.metadata.fromCache)
      if (collection === 'items') {
        switch (docChange.type) {
          case 'added': {
            if (source === 'Local') break
            const promise = findOrCreateNoteHelper(d).updateFromFirestore(d, source)
            if (!refs.isReady[collection]) noteHelperPromises.push(promise)
            break
          }
          case 'modified': {
            // console.log(docChange.type + ' note ' + docChange.doc.id + '(' + source + ')')
            if (source === 'Local') break
            const promise = findOrCreateNoteHelper(d).updateFromFirestore(d, source)
            if (!refs.isReady[collection]) noteHelperPromises.push(promise)
            break
          }
          case 'removed': {
            const promise = findOrCreateNoteHelper(d).destroy()
            if (!refs.isReady[collection]) noteHelperPromises.push(promise)
            break
          }
        }
      } else {
        switch (docChange.type) {
          case 'added':
            store.commit('add' + capitalizeFirstLetter(collection).slice(0, -1), d)
            break
          case 'removed':
            store.commit('remove' + capitalizeFirstLetter(collection).slice(0, -1), d.id)
            break
          case 'modified':
            // let source = docChange.doc.metadata.hasPendingWrites ? 'Local' : 'Server'
            // if (source === 'Local') break
            store.commit('modify' + capitalizeFirstLetter(collection).slice(0, -1), d)
            break
        }
      }
    })
    if (!refs.isReady[collection]) {
      refs.isReady[collection] = true
      await Promise.all(noteHelperPromises)
      updateReadyInStore()
    }
  })
}

function initFirestore () {
  refs.db = firebase.firestore()
  refs.storage = firebase.storage()
  firebase.auth().onAuthStateChanged(user => {
    store.commit('setCurrentUser', null)
    clearRefs()
    cancelAllOnSnapshot()

    if (user == null) {
      updateReadyInStore()
      return
    }

    store.commit('setFirestoreReady', false)

    refs.userDocRef = refs.db.collection('users').doc(user.uid)

    return refs.userDocRef.get().then(doc => {
      if (!doc.exists) {
        console.log('user does note exist!!!!')
        // User doc does not exist.  Create it!
        // return refs.userDocRef.set({
        //   displayName: user.displayName,
        //   email: user.email,
        //   photoURL: user.photoURL,
        //   settings: {
        //     editor: {
        //       showLineNumbers: true,
        //       tabSize: 2,
        //       fontSize: '18px',
        //       theme: 'monokai',
        //       fildStyle: 'markbegin',
        //       keyboardHandler: 'ace',
        //       printMargin: true,
        //       wrap: true
        //     }
        //   },
        //   sessions: [{name: 'Default', expandedTreeNoteIds: [], rootNoteId: null, spaceId: null}],
        //   rootItems: []
        // })
      }
    }).then(() => {
      cancellers['userDoc'] = refs.userDocRef.onSnapshot(doc => {
        store.commit('updateCurrentUser', { uid: doc.id, ...doc.data() })
      })
      addOnSnapshot('noteTemplates')
      addOnSnapshot('components')
      addOnSnapshot('items')
    }).catch((err) => {
      console.log(err)
    })
  }, (err) => {
    console.log(err)
  })
}

firebase.firestore().enablePersistence()
  .then(() => {
    store.commit('setOfflinePersistenceEnabled', true)
    initFirestore()
  }).catch(err => {
    store.commit('setOfflinePersistenceEnabled', false)
    if (err.code === 'failed-precondition') {
      // Multiple tabs open, persistence can only be enabled
      // in one tab at a time
      console.log('Multiple tabs open, persistence can only be enabled in one tab at a time')
      initFirestore()
    } else if (err.code === 'unimplemented') {
      // The current browser does not support all of the
      // features required to enable persistence
      alert('The current browser does not support all of the features required to enable persistence')
    }
  })

export default refs
